<app-common-header></app-common-header>
<div *ngIf="confirmWeb === false">
  <div class="col-12 text-center webview mb-2">
    <img src="assets/images/logo-charcoal.png" width="100" class="signimg" />
  </div>
  <div class="col-sm-12 p-0 ml-4">
    <a
      href="javascript:void(0)"
      class="backbtn webview mt-4"
      (click)="contactBack()"
    ></a>
  </div>
  <div class="container text-center pt-4 webview">
    <h1 class="col-sm-12 pt-5 pb-4 headlinesize">
      Thanks for answering my questions,<br />
      that was very helpful! Please confirm your info.
    </h1>
    <div class="container col-5 borderbox p-0 mb-4 box-shadow">
      <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
        <p class="text-left m-0 contactsubHead">
          Your Contact Info
          <a class="float-right mt-0 mr-2 editIcon" (click)="editContactInfo()"
            ><img src="assets/images/ediPencil.svg" width="15" />
          </a>
        </p>
      </div>
      <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mt-2">
        <div class="col-6 text-left">
          <div class="commercialColour labelSize">Your Name</div>
          <div class="wrdwrp inputsizeValues">{{ quesResponse.yourName }}</div>
        </div>
        <div class="col-6 text-left">
          <div class="commercialColour labelSize">Legal Entity Name</div>
          <div class="wrdwrp inputsizeValues">
            {{ quesResponse.legalEntityName }}
          </div>
        </div>
      </div>
      <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0">
        <div class="col-6 text-left">
          <div class="commercialColour labelSize">Email Address</div>
          <div class="wrdwrp inputsizeValues">
            {{ quesResponse.emailAddress }}
          </div>
        </div>
        <div class="col-6 text-left">
          <div class="commercialColour labelSize">Your Title / Position</div>
          <div class="wrdwrp inputsizeValues">
            {{ quesResponse.yourTitlePosition }}
          </div>
        </div>
      </div>
      <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0">
        <div class="col-6 text-left">
          <div class="commercialColour labelSize">Phone Number</div>
          <div class="wrdwrp inputsizeValues">
            {{ quesResponse.phoneNumber }}
          </div>
        </div>
        <div class="col-6 text-left">
          <div class="commercialColour labelSize">Best Time To Contact</div>
          <div class="wrdwrp inputsizeValues">
            {{ quesResponse.bestTimeToContact }}
          </div>
        </div>
      </div>
      <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0">
        <div class="col-6 text-left">
          <div class="commercialColour labelSize">Billing Address</div>
          <div class="wrdwrp inputsizeValues">
            {{ quesResponse.billingAddress }}
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let address of addresses; let i = index">
      <div class="container col-sm-5 px-0 d-flex my-2">
        <div class="col-sm-4 px-0 text-left">
          <div class="commercialColour labelSize">
            Service Address ({{ i + 1 }})
          </div>
        </div>
        <div class="col-sm-8 px-0 text-left">
          <div class="wrdwrp inputsizeValues">
            {{ address.formatedAddress }}
          </div>
        </div>
      </div>
      <div class="container col-5 px-0">
        <div class="borderbox p-0 mb-4 box-shadow">
          <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
            <p class="text-left m-0 contactsubHead">
              Your Product Preference
              <a class="float-right mt-0 mr-2 editIcon" (click)="editProduct(i)"
                ><img src="assets/images/ediPencil.svg" width="15" />
              </a>
            </p>
          </div>
          <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mt-2">
            <div class="col-6 text-left">
              <div class="commercialColour labelSize">Service Type</div>
              <div class="wrdwrp inputsizeValues">{{ services[i].value }}</div>
            </div>
            <div
              *ngIf="services[i].value === 'Switching Providers'"
              class="col-6 text-left"
            >
              <div class="commercialColour labelSize">
                Requested Product Type
              </div>
              <div class="wrdwrp inputsizeValues">
                {{ quesResponse.requestedProductType }}
              </div>
            </div>
            <div
              *ngIf="services[i].value === 'New Service'"
              class="col-6 text-left"
            >
              <div class="commercialColour labelSize">
                Permits & Inspections
              </div>
              <div class="wrdwrp inputsizeValues">
                {{ permissions[i].value }}
              </div>
            </div>
          </div>
          <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0">
            <div
              *ngIf="services[i].value === 'Switching Providers'"
              class="col-6 text-left"
            >
              <div
                class="commercialColour labelSize"
                style="line-height: 17px !important"
              >
                Contract Expiration Date
              </div>
              <div class="wrdwrp" style="line-height: 17px !important">
                {{ expirations[i].value }}
              </div>
            </div>
            <div
              *ngIf="services[i].value === 'New Service'"
              class="col-6 text-left"
              style="line-height: 17px !important"
            >
              <div class="commercialColour labelSize">Project Type</div>
              <div class=" ">
                {{ projects[i].value }}
                <!-- <a class="fa fa-calendar"></a> -->
              </div>
            </div>
            <div
              *ngIf="services[i].value === 'Switching Providers'"
              class="col-6 text-left"
            >
              <div
                class="commercialColour labelSize"
                style="line-height: 17px !important"
              >
                Requested Switch Date
              </div>
              <div class="wrdwrp" style="line-height: 17px !important">
                {{ switchDates[i] | date: 'mediumDate' }}
              </div>
            </div>
            <div
              *ngIf="services[i].value === 'New Service'"
              class="col-6 text-left"
            >
              <div
                class="commercialColour labelSize"
                style="line-height: 17px !important"
              >
                Requested Start Date
              </div>
              <div class="wrdwrp" style="line-height: 17px !important">
                {{ switchDates[i] | date: 'mediumDate' }}
              </div>
            </div>
          </div>
          <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0">
            <div class="col-6 text-left">
              <div class=""></div>
              <div class="wrdwrp"></div>
            </div>
            <div class="col-6 text-left">
              <div class="commercialColour labelSize">
                Requested Contract Term
              </div>
              <div class="wrdwrp inputsizeValues">
                {{ quesResponse.requestedContractTerm }}
              </div>
            </div>
          </div>
        </div>
        <hr *ngIf="i !== addresses.length - 1" />
      </div>
    </div>
    <button
      class="btn sectbtn signinpad mt-4 pl-3 pr-3 mb-5 confirmBtnSize"
      (click)="contactConfirmPro()"
    >
      CONFIRM
    </button>
  </div>
</div>

<!-- Web view Contact info Edit mode -->
<div
  class="modal fade webview"
  data-backdrop="static"
  data-keyboard="false"
  id="contactModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content zind1">
      <div class="modal-body p-0 mb-3">
        <img
          src="assets/images/editClose.svg"
          class="close videoclose outlinee closeBtn pt-3"
          width="15"
          (click)="modelContactClose()"
        />
        <div class="service-modal">
          <div class="bdy-sec p-0">
            <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
              <p class="text-left m-0 editText">Edit Your Contact Info</p>
            </div>
            <form
              name="form"
              (ngSubmit)="createAccount($event, f, f.form.valid, 'webContact')"
              #f="ngForm"
              novalidate
            >
              <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mt-2">
                <div class="col-6 text-left">
                  <div class="lneHegt commercialColour editLabel">
                    Your Name
                  </div>
                  <input
                    type="text"
                    class="form-control inputBox editLabel"
                    id="yourName"
                    name="YourName"
                    [(ngModel)]="quesResponse.yourName"
                    #yourName="ngModel"
                    (input)="legalClick()"
                  />
                </div>
                <div class="col-6 text-left">
                  <div class="lneHegt commercialColour editLabel">
                    Legal Entity Name
                  </div>
                  <input
                    type="text"
                    class="form-control inputBox editLabel"
                    id="legalEntityName"
                    name="LegalEntityName"
                    [(ngModel)]="quesResponse.legalEntityName"
                    #legalEntityName="ngModel"
                    (input)="legalClick()"
                  />
                </div>
              </div>
              <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0">
                <div class="col-6 text-left">
                  <label
                    class="commercialColour editLabel"
                    for="email"
                    style="line-height: 17px !important"
                    >Email Address</label
                  >
                  <input
                    type="text"
                    id="contactEmail"
                    class="form-control inputBox editLabel"
                    name="email"
                    [(ngModel)]="quesResponse.emailAddress"
                    #email="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
                    required
                    email
                    pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
                    (input)="legalClick()"
                  />
                  <div class="invalid-feedback posabs">
                    <div
                      class="boxcolour"
                      *ngIf="
                        f.submitted &&
                        email.invalid &&
                        email.errors &&
                        email.errors.required
                      "
                    >
                      <span
                        class="fa fa-exclamation-circle mr-1"
                        type="Icon"
                      ></span
                      >Email is required
                    </div>
                    <div
                      [hidden]="
                        email.valid || email.pristine || !email.errors.pattern
                      "
                      class="boxcolour"
                    >
                      <span
                        class="fa fa-exclamation-circle mr-1"
                        type="Icon"
                      ></span
                      >Please enter a valid email
                    </div>
                  </div>
                </div>
                <div class="col-6 text-left">
                  <div class="lneHegt commercialColour editLabel">
                    Your Title / Position
                  </div>
                  <input
                    type="text"
                    class="form-control inputBox editLabel"
                    id="yourTitlePosition"
                    name="YourTitlePosition"
                    [(ngModel)]="quesResponse.yourTitlePosition"
                    #yourTitlePosition="ngModel"
                    (input)="legalClick()"
                  />
                </div>
              </div>
              <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0">
                <div class="col-6 text-left">
                  <label
                    class="commercialColour editLabel"
                    for="phonenumber"
                    style="line-height: 17px !important"
                    >Phone Number</label
                  >
                  <input
                    type="text"
                    class="form-control inputBox editLabel"
                    name="PhoneNumber"
                    id="phone"
                    [(ngModel)]="quesResponse.phoneNumber"
                    appPhoneNumber
                    #phone="ngModel"
                    maxlength="12"
                    [ngClass]="{ 'is-invalid': f.submitted && phone.invalid }"
                    required
                    (input)="legalClick()"
                  />
                  <div class="invalid-feedback posabs">
                    <div
                      class="boxcolour"
                      *ngIf="
                        f.submitted &&
                        phone.invalid &&
                        phone.errors &&
                        phone.errors.required
                      "
                    >
                      <span
                        class="fa fa-exclamation-circle mr-1"
                        type="Icon"
                      ></span>
                      Phone number is required
                    </div>
                    <div
                      [hidden]="phone.valid || phone.pristine"
                      class="boxcolour"
                    >
                      <span
                        class="fa fa-exclamation-circle mr-1"
                        type="Icon"
                      ></span>
                      Please enter a valid phone number
                    </div>
                  </div>
                </div>
                <div class="col-6 text-left">
                  <div class="lneHegt commercialColour editLabel">
                    Best Time To Contact
                  </div>
                  <!-- <input type="text" class="form-control inputBox editLabel" id="bestTimeToContact" name="BestTimeToContact" [(ngModel)]="quesResponse.bestTimeToContact" #bestTimeToContact="ngModel" /> -->

                  <select
                    class="dropdown-toggle form-control inputBox editLabel minhgt45"
                    id="bestTimeToContact"
                    name="BestTimeToContact"
                    [(ngModel)]="quesResponse.bestTimeToContact"
                    #bestTimeToContact="ngModel"
                  >
                    <option value="8am - 11am">8am - 11am</option>
                    <option value="11am - 2pm">11am - 2pm</option>
                    <option value="2pm - 6pm">2pm - 6pm</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-12 mb-2 ml-0 mr-0">
                <div class="lneHegt commercialColour editLabel">
                  Billing Address
                </div>
                <div class="row col-sm-12 m-0 p-0">
                  <div class="col-9 text-left p-0">
                    <input
                      type="text"
                      class="form-control inputBox editLabel"
                      id="billingAddress"
                      name="BillingAddress"
                      [(ngModel)]="quesResponse.billingAddress"
                      #billingAddress="ngModel"
                      (input)="legalClick()"
                    />
                  </div>

                  <!-- <div class="col-3 text-left pr-0">
                    <div class="lneHegt commercialColour editLabel"></div>
                    <input type="text" class="form-control inputBox editLabel" value="Suite #" />
                  </div> -->
                </div>
              </div>

              <div class="pr-3">
                <button
                  [disabled]="contactSaveBtn"
                  class="btn-gry handsymbol float-right mt-1 editSave"
                  type="submit"
                >
                  SAVE
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Web view Edit product preference -->
<div
  class="modal fade webview"
  data-backdrop="static"
  data-keyboard="false"
  id="productModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content zind1">
      <div class="modal-body p-0 mb-3">
        <img
          src="assets/images/editClose.svg"
          class="close videoclose outlinee closeBtn pt-3"
          width="15"
          (click)="modelProductClose()"
        />
        <div class="service-modal datepicker">
          <div class="p-0">
            <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
              <p class="text-left m-0 editText">
                Edit Your Product Preferences
              </p>
            </div>
            <form
              name="productForm"
              (ngSubmit)="
                createProductPreference($event, f1, f1.form.valid, 'webProd')
              "
              #f1="ngForm"
              novalidate
            >
              <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mt-2">
                <div class="col-6 text-left">
                  <div class="lneHegt commercialColour editLabel">
                    Service Type
                  </div>
                  <input
                    disabled
                    type="text"
                    class="form-control inputBox editLabel"
                    id="serviceType"
                    name="ServiceType"
                    [(ngModel)]="services[index].value"
                    #serviceType="ngModel"
                  />
                </div>
                <div
                  *ngIf="services[index].value === 'Switching Providers'"
                  class="col-6 text-left"
                >
                  <div class="lneHegt commercialColour editLabel">
                    Requested Product Type
                  </div>
                  <!-- <input type="text" class="form-control inputBox editLabel" id="requestedProductType" name="RequestedProductType" [(ngModel)]="quesResponse.requestedProductType" #requestedProductType="ngModel" /> -->
                  <select
                    class="dropdown-toggle form-control inputBox editLabel minhgt45"
                    (ngModelChange)="textChanged($event)"
                    id="requestedProductType"
                    name="RequestedProductType"
                    [(ngModel)]="quesResponse.requestedProductType"
                    #requestedProductType="ngModel"
                  >
                    <option value="Fixed rate">Fixed rate</option>
                    <option value="Variable & index rate">
                      Variable & index rate
                    </option>
                  </select>
                </div>

                <div
                  *ngIf="services[index].value === 'New Service'"
                  class="col-6 text-left"
                >
                  <div class="lneHegt commercialColour editLabel">
                    Permits & Inspections
                  </div>
                  <!-- <input type="text" class="form-control inputBox editLabel" id="permitsInspection" name="PermitsInspection" [(ngModel)]="quesResponse.reqpermits" #permitsInspection="ngModel" /> -->
                  <select
                    class="dropdown-toggle form-control inputBox editLabel minhgt45"
                    id="permitsInspection"
                    name="PermitsInspection"
                    (ngModelChange)="permitsInspectionChanged($event, index)"
                    [(ngModel)]="permissions[index].value"
                    #permitsInspection="ngModel"
                  >
                    <option value="Yes">Yes</option>
                    <option value="No, not yet">No, not yet</option>
                    <option value="Not necessary">Not necessary</option>
                    <option value="I need to get a permit?">
                      I need to get a permit?
                    </option>
                  </select>
                </div>
              </div>
              <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0">
                <div
                  *ngIf="
                    services[index].value === 'Switching Providers' &&
                    expirations[index].value !== 'No, already expired'
                  "
                  class="col-6 text-left"
                >
                  <div class="lneHegt commercialColour editLabel">
                    Contract Expiration Date
                  </div>
                  <div class="wrdwrp lneHegt editLabel">
                    <div class="datePickerShow">
                      <my-date-picker
                        name="mydate1"
                        id="date1"
                        [options]="myDatePickerOptions1"
                        [(ngModel)]="model"
                        placeholder="DD/MM/YYYY"
                        required
                      ></my-date-picker>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="
                    services[index].value === 'Switching Providers' &&
                    expirations[index].value === 'No, already expired'
                  "
                  class="col-6 text-left"
                >
                  <div class="lneHegt commercialColour editLabel">
                    Contract Expiration Date
                  </div>
                  <div class="wrdwrp">No, already expired</div>
                </div>
                <div
                  *ngIf="services[index].value === 'New Service'"
                  class="col-6 text-left"
                >
                  <div class="commercialColour editLabel">Project Type</div>
                  <div class="editLabel" style="line-height: 17px !important">
                    <!-- <input type="text" class="form-control inputBox editLabel" id="projectType" name="ProjectType" [(ngModel)]="quesResponse.projectType" #projectType="ngModel" />                  -->
                    <select
                      class="dropdown-toggle form-control inputBox editLabel minhgt45"
                      id="projectType"
                      name="ProjectType"
                      (ngModelChange)="ProjectTypeChanged($event, index)"
                      [(ngModel)]="projects[index].value"
                      #projectType="ngModel"
                    >
                      <option value="New construction">New construction</option>
                      <option value="Building renovation">
                        Building renovation
                      </option>
                      <option value="Company expansion / New location">
                        Company expansion / New location
                      </option>
                      <option value="Change of ownership">
                        Change of ownership
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  *ngIf="services[index].value === 'Switching Providers'"
                  class="col-6 text-left"
                >
                  <div class="lneHegt commercialColour editLabel">
                    Requested Switch Date
                  </div>
                  <div class="wrdwrp lneHegt editLabel">
                    <div class="datePickerShow">
                      <my-date-picker
                        name="mydate2"
                        id="date2"
                        [options]="myDatePickerOptions2"
                        [(ngModel)]="switchModel"
                        placeholder="DD/MM/YYYY"
                        required
                      ></my-date-picker>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="services[index].value === 'New Service'"
                  class="col-6 text-left"
                >
                  <div class="lneHegt commercialColour editLabel">
                    Requested Start Date
                  </div>
                  <div class="wrdwrp lneHegt editLabel">
                    <div class="datePickerShow">
                      <my-date-picker
                        name="mydate3"
                        id="date3"
                        [options]="myDatePickerOptions3"
                        [(ngModel)]="startDateValue"
                        placeholder="DD/MM/YYYY"
                        required
                      ></my-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0">
                <div class="col-6 text-left">
                  <div class="lneHegt"></div>
                  <div class="wrdwrp lneHegt"></div>
                </div>
                <div class="col-6 text-left">
                  <div class="lneHegt commercialColour editLabel">
                    Requested Contract Term
                  </div>
                  <!-- <input type="text" class="form-control inputBox editLabel" id="requestedContractTerm" name="RequestedContractTerm" [(ngModel)]="quesResponse.requestedContractTerm" #requestedContractTerm="ngModel" /> -->
                  <select
                    class="dropdown-toggle form-control inputBox editLabel minhgt45"
                    id="requestedContractTerm"
                    name="RequestedContractTerm"
                    (ngModelChange)="RequestedContractTermChanged($event)"
                    [(ngModel)]="quesResponse.requestedContractTerm"
                    #requestedContractTerm="ngModel"
                  >
                    <option value="6 Months">6 Months</option>
                    <option value="12 Months">12 Months</option>
                    <option value="18 Months">18 Months</option>
                    <option value="24 Months">24 Months</option>
                    <option value="30 Months">30 Months</option>
                    <option value="36 Months">36 Months</option>
                    <option value="48 Months">48 Months</option>
                    <option value="60 Months">60 Months</option>
                    <option value="I don't know">I don't know</option>
                  </select>
                </div>
              </div>
              <div class="pr-3">
                <button
                  class="btn-gry handsymbol float-right mt-1 editSave pl-3 pr-3 saveBtnBusiness productModel"
                  type="submit"
                >
                  SAVE
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Location Web view -->
<div *ngIf="confirmWeb" class="webview">
  <div class="col-12 text-center webview">
    <img src="assets/images/logo-charcoal.png" width="100" class="signimg" />
  </div>
  <div class="col-sm-12 p-0 ml-4">
    <a
      href="javascript:void(0)"
      class="backbtn webview mt-4"
      (click)="businessBack()"
    ></a>
  </div>
  <div class="container text-center webview">
    <h1 class="col-sm-12 pt-5 mt-5 pb-4 mainHead">
      Please confirm your location details. <br />
      To receive accurate, custom pricing options, we <br />require two recent
      energy bills for each ESI ID.<br />
    </h1>
    <div class="m-auto col-5 borderbox datepicker p-0 mb-4 box-shadow">
      <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
        <p class="text-left m-0 lneHegt subHeading">
          Your business locations
          <span *ngIf="addresses.length > 0">({{ addresses.length }})</span>
          <a class="float-right mt-0 mr-2 editIcon" (click)="editLocation()"
            ><img src="assets/images/ediPencil.svg" width="15" />
          </a>
        </p>
      </div>
      <div class="contactInfobotm mb-1 ml-2 mr-2">
        <div
          *ngFor="let addressObj of addresses; let i = index"
          class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mt-2"
        >
          <div class="col-5 text-left pr-0">
            <div class="col-md-12 mb-2 px-0">
              <agm-map
                [latitude]="addressObj.geoMapAddress.geometry.location.lat"
                [longitude]="addressObj.geoMapAddress.geometry.location.lng"
                [zoomControl]="false"
                [disableDoubleClickZoom]="true"
                [zoom]="18"
                [scrollwheel]="false"
                [streetViewControl]="false"
              >
                <agm-marker
                  [latitude]="addressObj.geoMapAddress.geometry.location.lat"
                  [longitude]="addressObj.geoMapAddress.geometry.location.lng"
                  [iconUrl]="markerIconUrl()"
                ></agm-marker>
              </agm-map>
            </div>
          </div>
          <div class="col-7 text-left">
            <div class="lneHegt commercialColour serviceAddress">
              Service Address ({{ i + 1 }})
            </div>

            <div class="wrdwrp lneHegt serviceAddressContent">
              {{ addressObj.formatedAddress }}<br />
              TDSP: {{ addressObj.utility }}
              <!-- {{addressObj.pointer_name}} -->
              <br />
              <p
                class="mb-1"
                *ngFor="let esiid of addressObj.esiids; let j = index"
              >
                ESI ID: {{ esiid.value }}
              </p>
              <p>
                Requested switch date: {{ switchDates[i] | date: mediumDate }}
              </p>
              <!-- <div *ngFor="let switchDate of requestSwitchDateValue; let p = index;">
                    Requested switch date: {{ getDateFormat(switchDate.value.date) }}
                  </div>  -->

              <!-- <p class="mb-1">Requested switch date:</p> -->
              <!-- {{switchDates[i] | date: 'mediumDate'}} -->
            </div>
          </div>
          <div class="text-center m-auto dragMsg">
            Receive accurate, tailored pricing options
          </div>
          <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0 borfderbtm">
            <div class="col-sm-12 text-center font16 semi-bold oneSpaces mb-2">
              <label
                class="upload-button text-center handsymbol boxbackgrdclr"
                [ngClass]="{ 'another-file-over': hasAnotherDropZoneOver }"
              >
                <div
                  ng2FileDrop
                  (fileOver)="fileOverAnother($event, i)"
                  [uploader]="uploader"
                >
                  <span style="line-height: 100%">
                    <p
                      class="font16 semi-bold oneSpaces mt-3 fileUploadbottom fileUploadbottomHgt"
                    >
                      DRAG AND DROP OR CLICK HERE TO UPLOAD
                    </p>
                    <p
                      class="font13 oneSpaces regularfontFamily fileUploadbottom fileUploadbottomHgt"
                    >
                      Max File Size: 10MB
                    </p>
                    <p
                      class="font13 oneSpaces regularfontFamily pb-2 fileUploadbottom fileUploadbottomHgt"
                    >
                      Acceptable File Types: JPG, PNG, PDF
                    </p>
                  </span>
                </div>
                <input
                  type="file"
                  name="{{ 'addressId-' + i }}"
                  ng2FileSelect
                  id="{{ 'file' + i }}"
                  (click)="onTempImageSelected($event, i)"
                  [uploader]="uploader"
                  accept=".jpg,.pdf,.jpeg,.png,.svg,.bmp"
                  multiple
                />
              </label>
              <ul class="upldfile">
                <li *ngFor="let fileobj of uploader.queue">
                  <div
                    class="handsymbol uploded"
                    *ngIf="i === fileobj.file.fileIndex"
                  >
                    <i class="fa fa-file mr-2"></i>
                    <span
                      >{{ fileobj.file.name }}
                      <small class="text-muted clearfix float-left w-100">{{
                        fileobj.file.unitSize
                      }}</small>
                    </span>
                    <font class="upldclose" (click)="removeFile(fileobj)"
                      >x</font
                    >
                  </div>
                </li>
                <li class="uploaderror" *ngIf="invalidFileMsg">
                  Please provide image or pdf files
                </li>
                <li class="uploaderror" *ngIf="invalidFileSizeMsg">
                  File(s) size shouldn't exceed 10 MB
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 ml-2 mr-2"></div>
    </div>
    <button
      class="btn sectbtn signinpad mt-4 pl-3 pr-3 mb-5 confirmBtn"
      (click)="submitFiles()"
    >
      CONFIRM
    </button>
  </div>
</div>

<!-- Edit business location WebView -->
<div
  class="modal fade webview"
  data-backdrop="static"
  data-keyboard="false"
  id="businessLocation"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content zind1">
      <div class="modal-body p-0 mb-3">
        <img
          src="assets/images/editClose.svg"
          class="close videoclose outlinee closeBtn pt-3"
          width="15"
          (click)="modellocationClose()"
        />
        <div class="service-modal">
          <div class="bdy-sec p-0">
            <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
              <p class="text-left m-0 lneHegt editSubHeading">
                Edit your location details
              </p>
            </div>
            <div class="p-0 mb-4 scrollEditModel">
              <div class="contactInfobotm mb-1 ml-2 mr-2">
                <div
                  *ngFor="let addressObj of temporaryAddresses; let i = index"
                  class="row col-sm-12 mb-5 ml-0 mr-0 p-0 mt-2"
                >
                  <div class="col-5 text-left pr-0">
                    <div class="col-md-12 mb-2 px-0">
                      <agm-map
                        [latitude]="
                          addressObj.geoMapAddress.geometry.location.lat
                        "
                        [longitude]="
                          addressObj.geoMapAddress.geometry.location.lng
                        "
                        [zoomControl]="false"
                        [disableDoubleClickZoom]="true"
                        [zoom]="18"
                        [scrollwheel]="false"
                        [streetViewControl]="false"
                      >
                        <agm-marker
                          [latitude]="
                            addressObj.geoMapAddress.geometry.location.lat
                          "
                          [longitude]="
                            addressObj.geoMapAddress.geometry.location.lng
                          "
                          [iconUrl]="markerIconUrl()"
                          id="editAutoComplete"
                        ></agm-marker>
                      </agm-map>
                      <!-- <div class="" *ngFor="let switchDate of requestSwitchDateValue; let p = index;">
                            <font class="commercialColour">Requested switch date:</font>   {{ getDateFormat(switchDate.value.date) }} 
                            </div>  -->
                      <p class="commercialColour mb-0">
                        Requested switch date:
                      </p>
                      <font class="mb-3 commercialColour">{{
                        switchDates[i] | date: mediumDate
                      }}</font>
                    </div>
                  </div>
                  <div class="col-7 text-left pr-5">
                    <div class="lneHegt commercialColour serviceAddress">
                      Service Address ({{ i + 1 }})
                    </div>

                    <div class="wrdwrp lneHegt serviceAddressContent">
                      <!-- {{addressObj.formatedAddress}} -->
                      <div class="d-flex mb-2 mt-1">
                        <!-- <div class="col-9 pl-0">
                          <input type="text" id="addAddress{{i}}" name="AddAddress" [(ngModel)]="addressObj.formatedAddress" #addAddress="ngModel" class="form-control editServiceHead" />
                        </div> -->
                        <div class="col-12 px-0">
                          <input
                            ngx-google-places-autocomplete
                            [options]="options"
                            #places="ngx-places"
                            (ngModelChange)="setFlag()"
                            (keydown.space)="
                              addressObj.formatedAddress
                                ? null
                                : $event.preventDefault()
                            "
                            (onAddressChange)="handleAddressChange($event, i)"
                            type="text"
                            id="autocomplete"
                            class="form-control inputBox editServiceHead"
                            placeholder="Street address, City, State"
                            id="addAddress{{ i }}"
                            name="AddAddress"
                            [(ngModel)]="addressObj.formatedAddress"
                            #addAddress="ngModel"
                          />
                        </div>
                        <!-- <div class="col-3 p-0">
                            <input type="text" value="#suite" class="form-control editServiceHead" />
                          </div> -->
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col pt-3 pr-0 pl-0 commercialColour">
                          TDSP:
                        </div>
                        <div
                          class="col-9 p-0"
                          *ngIf="
                            !showUtilities ||
                            i !== addressIndex ||
                            utilities.length == 1
                          "
                        >
                          <!-- <input type="text" id="pointerName" name="PointerName" [(ngModel)]="addressObj.pointer_name" #pointerName="ngModel" class="form-control editServiceHead" /> -->
                          <input
                            type="text"
                            id="pointerName"
                            name="PointerName"
                            readonly
                            value="{{ addressObj.utility }}"
                            class="form-control inputBox editServiceHead"
                          />
                          <!-- {{addressObj.pointer_name}} -->
                        </div>
                        <div
                          class="col-9 p-0"
                          id="commercial"
                          *ngIf="
                            showUtilities &&
                            i == addressIndex &&
                            utilities.length > 1
                          "
                        >
                          <ng-select
                            [items]="utilities"
                            bindLabel="Utility"
                            bindValue="Utility"
                            placeholder="Please Select"
                            [searchable]="false"
                            [clearable]="false"
                            (change)="selectUtility(selectedUtility)"
                            [(ngModel)]="selectedUtility"
                          >
                          </ng-select>
                        </div>
                      </div>

                      <div
                        class="d-flex mb-2"
                        *ngFor="let esiid of addressObj.esiids; let j = index"
                      >
                        <div class="col pt-3 pr-0 pl-0 commercialColour">
                          ESI ID{{ j + 1 }}:
                        </div>
                        <div class="col-9 p-0">
                          <input
                            type="text"
                            id="esiidVal{{ i }}"
                            name="EsiidVal"
                            [(ngModel)]="esiid.value"
                            #esiidVal="ngModel"
                            class="form-control inputBox editServiceHead"
                          />
                          <span class="CloseEssid"
                            ><img
                              class="outlinee closeBtn"
                              src="assets/images/editClose.svg"
                              (click)="essidClose(i, j)"
                              width="15"
                          /></span>
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                  <div class="row col-12 pr-5">
                    <div
                      class="col-9 text-left font15 calibre-light errclr pull-left pr-0"
                    >
                      <p
                        class="mb-0"
                        *ngIf="utilities.length < 1 && !isAddressSelected"
                      >
                        Your Zip Code is not in a serviceable area at this time.
                        Please check back soon or send us an email.
                      </p>
                    </div>
                    <div class="col-3 pull-right">
                      <div
                        class="btn sectbtn signinpad mt-0 mb-0 addBusiness"
                        (click)="addEsiid(i)"
                      >
                        Add ESI ID
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
            <div class="text-center">
              <button
                class="btn sectbtn signinpad mt-2 pl-3 pr-3 mb-2 editSaveBtn"
                type="submit"
                [disabled]="!isAddressSelected"
                [ngClass]="{ combtn: isAddressSelected }"
                (click)="businessEdit('webBusiness')"
              >
                SAVE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mobile view contact info -->
<div class="container mobileview mt-4 pt-4">
  <div
    *ngIf="
      showConfirmContactInfo &&
      showMobileproductEdit === false &&
      ShowMobileModel === false &&
      mbEditShowLocation === false
    "
  >
    <div class="col-12 d-flex px-0 mt-4">
      <div class="justify-content-center align-self-center col-sm-3 col-3 px-0">
        <img
          style="width: 100% !important"
          src="assets/images/logo-charcoal.png"
        />
      </div>
      <div class="col-sm-9 col-9 pr-0 my-auto">
        <div class="arrow_box">
          <h1 class="questionMob text-left mbmainHeading evaMsg pl-2">
            Thanks for answering my questions, that was very helpful! We are
            almost done. Please confirm your contact info.
          </h1>
        </div>
      </div>
    </div>
    <!-- Show the contact info model -->
    <div class="h-100 mt-3">
      <div class="col-10 m-auto float-right borderbox p-0 mb-4">
        <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
          <p class="text-left m-0 lneHegt contactsubHead">
            Your contact info
            <a
              class="float-right mt-0 mr-2 editIcon"
              (click)="editContactMobileInfo()"
              ><img src="assets/images/ediPencil.svg" width="15" />
            </a>
          </p>
        </div>
        <div class="col-12 text-left py-1">
          <div class="lneHegt commercialColour labelSize">Your Name</div>
          <div class="wrdwrp inputsizeValues">{{ quesResponse.yourName }}</div>
        </div>
        <div class="col-12 text-left py-1">
          <div class="lneHegt commercialColour labelSize">Phone Number</div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ quesResponse.phoneNumber }}
          </div>
        </div>
        <div class="col-12 text-left py-1">
          <div class="lneHegt commercialColour labelSize">Email Address</div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ quesResponse.emailAddress }}
          </div>
        </div>
        <div class="col-12 text-left py-1">
          <div class="lneHegt commercialColour labelSize">
            Legal Entity Name
          </div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ quesResponse.legalEntityName }}
          </div>
        </div>
        <div class="col-12 text-left py-1">
          <div class="lneHegt commercialColour labelSize">
            Your Title / Position
          </div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ quesResponse.yourTitlePosition }}
          </div>
        </div>
        <div class="col-12 text-left py-1">
          <div class="lneHegt commercialColour labelSize">
            Best Time To Contact
          </div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ quesResponse.bestTimeToContact }}
          </div>
        </div>
        <div class="col-12 text-left py-1">
          <div class="lneHegt commercialColour labelSize">Billing Address</div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ quesResponse.billingAddress }}
          </div>
        </div>
      </div>
      <div class="col-10 m-auto float-right p-0">
        <label
          class="custom-control custom-checkbox mb-2 mt-4 w-100 chkbox pl-0"
        >
          <input
            class="custom-control-input mgntp10 ng-valid ng-dirty ng-touched"
            id="confirm1"
            name="property"
            type="checkbox"
            value="confirm"
            [ngx-scroll-to]="'#prodPreference'"
            [ngx-scroll-to-duration]="10"
            (click)="confirmBtn('web')"
          />
          <label class="custom-control-label font20 confirmBtn" for="confirm1"
            >Confirm</label
          ></label
        >
      </div>
      <div *ngIf="confirmcheckbox" class="col-10 m-auto float-right p-0">
        <div class="col-12 p-0 w-100 text-right">
          <div
            class="mb-3 ash_box text-right ng-tns-c16-2 ng-trigger ng-trigger-flyOutans ng-star-inserted"
            style="transform: translateX(0px)"
          >
            <h1 class="ansMob text-right confirmMsg">
              Confirmed, everything is correct
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Show product preference model Mobile-->

  <div
    class="col-12 d-flex px-0"
    *ngIf="
      (ShowConfirmProduct ||
        (confirmcheckbox &&
          showMobileproductEdit === false &&
          ShowMobileModel === false)) &&
      mbEditShowLocation === false &&
      ShowMobileModel === false
    "
  >
    <div class="justify-content-center align-self-center col-sm-3 col-3 px-0">
      <img
        style="width: 100% !important"
        src="assets/images/logo-charcoal.png"
      />
    </div>
    <div class="col-sm-9 col-9 pr-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left mbmainHeading evaMsg pl-2">
          Did I correctly capture your contract requests and product
          preferences?
        </h1>
      </div>
    </div>
  </div>

  <div
    *ngIf="
      (ShowConfirmProduct ||
        (confirmcheckbox &&
          showMobileproductEdit === false &&
          ShowMobileModel === false)) &&
      mbEditShowLocation === false &&
      ShowMobileModel === false
    "
    class="h-100 mt-3"
  >
    <div *ngFor="let address of addresses; let i = index">
      <div class="col-10 float-right p-0">
        <div class="col-sm-4 px-0 text-left">
          <div class="commercialColour labelSize">
            Service Address ({{ i + 1 }})
          </div>
        </div>
        <div class="col-sm-8 px-0 text-left">
          <div class="wrdwrp inputsizeValues">
            {{ address.formatedAddress }}
          </div>
        </div>
      </div>
      <div id="prodPreference" class="col-10 float-right borderbox p-0 mb-4">
        <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
          <p class="text-left m-0 lneHegt contactsubHead">
            Your product preferences
            <a
              class="float-right mt-0 mr-2 editIcon"
              (click)="editProductMobile(i)"
              ><img src="assets/images/ediPencil.svg" width="15" />
            </a>
          </p>
        </div>
        <div class="col-12 text-left py-1">
          <div class="lneHegt commercialColour labelSize">Service Type</div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ services[i].value }}
          </div>
        </div>
        <div
          *ngIf="services[i].value === 'Switching Providers'"
          class="col-12 text-left py-1"
        >
          <div
            class="commercialColour labelSize"
            style="line-height: 17px !important"
          >
            Contract expiration date
          </div>
          <div class="wrdwrp inputsizeValues">
            {{ expirations[i].value }}
            <!-- <a class="fa fa-calendar"></a> -->
          </div>
        </div>
        <div
          *ngIf="services[i].value === 'New Service'"
          class="col-12 text-left py-1"
        >
          <div
            class="commercialColour labelSize"
            style="line-height: 17px !important"
          >
            Project Type
          </div>
          <div class="inputsizeValues" style="line-height: 17px !important">
            {{ projects[i].value }}
          </div>
        </div>
        <div
          *ngIf="services[i].value === 'Switching Providers'"
          class="col-12 text-left py-1"
        >
          <div class="lneHegt commercialColour labelSize">Product Type</div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ quesResponse.requestedProductType }}
          </div>
        </div>
        <div
          *ngIf="services[i].value === 'New Service'"
          class="col-12 text-left py-1"
        >
          <div class="lneHegt commercialColour labelSize">
            <!-- Product Type</div>
                <div class="wrdwrp lneHegt inputsizeValues">{{ quesResponse.reqpermits }}</div> -->
            Permits & inspections
          </div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ permissions[i].value }}
          </div>
        </div>
        <div
          *ngIf="services[i].value === 'Switching Providers'"
          class="col-12 text-left py-1"
        >
          <div class="lneHegt commercialColour labelSize">
            Requested Switch Date
          </div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ switchDates[i] | date: 'mediumDate' }}
            <!-- <a class="fa fa-calendar"></a> -->
          </div>
        </div>
        <div
          *ngIf="services[i].value === 'New Service'"
          class="col-12 text-left py-1"
        >
          <div class="lneHegt commercialColour labelSize">
            Requested Start Date
          </div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ switchDates[i] | date: 'mediumDate' }}
            <!-- <a class="fa fa-calendar"></a> -->
          </div>
        </div>
        <div class="col-12 text-left py-1">
          <div class="lneHegt commercialColour labelSize">
            Requested Contract Term
          </div>
          <div class="wrdwrp lneHegt inputsizeValues">
            {{ quesResponse.requestedContractTerm }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-10 m-auto float-right p-0">
      <label class="custom-control custom-checkbox mb-2 mt-3 w-100 chkbox pl-0">
        <input
          type="checkbox"
          class="custom-control-input"
          id="confirm2"
          name="example2"
          [ngx-scroll-to]="'#businessLocationScroll'"
          [ngx-scroll-to-duration]="10"
          (click)="confirmYesBtn()"
        />
        <label class="custom-control-label confirmBtn" for="confirm2"
          >Yes</label
        ></label
      >
    </div>
    <div *ngIf="yesCheckBox" class="col-10 m-auto float-right p-0">
      <div class="col-12 p-0 w-100 text-right">
        <div
          class="mb-3 ash_box text-right ng-tns-c16-2 ng-trigger ng-trigger-flyOutans ng-star-inserted"
          style="transform: translateX(0px)"
        >
          <h1 class="ansMob text-right confirmMsg">Yes, you did good</h1>
        </div>
      </div>
    </div>
  </div>

  <!-- Show the contact info edit model -->
  <div
    *ngIf="
      ShowMobileModel &&
      showMobileproductEdit === false &&
      mbEditShowLocation === false
    "
  >
    <div class="col-12 d-flex row">
      <div class="justify-content-center align-self-center col-sm-3 col-3 px-0">
        <img
          style="width: 100% !important"
          src="assets/images/logo-charcoal.png"
        />
      </div>
      <div class="col-sm-9 col-9 px-0 my-auto">
        <div class="arrow_box">
          <h1 class="questionMob text-left mbmainHeading evaMsg pl-2 mt-3">
            Thanks for answering my questions, that was very helpful! Please
            confirm your info.
          </h1>
        </div>
      </div>
    </div>
    <div class="col-10 m-auto p-0">
      <div class="w-100 d-inline-block p-0 borderbox mb-4 mt-4 pb-3">
        <img
          src="assets/images/editClose.svg"
          class="close videoclose outlinee closeBtn pt-2 mr-2"
          width="15"
          (click)="mobileContactClose()"
        />
        <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
          <p class="text-left m-0 lneHegt editText">Edit your contact info</p>
        </div>
        <form
          name="form"
          (ngSubmit)="createAccount($event, f, f.form.valid, 'mobileContact')"
          #f="ngForm"
          novalidate
        >
          <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mt-2">
            <div class="col-12 text-left">
              <div class="lneHegt commercialColour editLabel">Your name</div>
              <input
                type="text"
                class="form-control inputBox editLabel"
                id="yourNamemb"
                name="YourNamemb"
                [(ngModel)]="quesResponse.yourName"
                #yourNamemb="ngModel"
              />
            </div>
            <div class="col-12 text-left">
              <label
                class="commercialColour editLabel"
                for="phonenumber"
                style="line-height: 17px !important"
                >Phone number</label
              >

              <input
                type="text"
                class="form-control inputBox editLabel"
                name="PhoneNumber"
                id="phone"
                [(ngModel)]="quesResponse.phoneNumber"
                appPhoneNumber
                #phone="ngModel"
                maxlength="12"
                [ngClass]="{ 'is-invalid': f.submitted && phone.invalid }"
                (ngModelChange)="legalClick()"
                required
              />
              <div class="invalid-feedback posabs">
                <div
                  class="boxcolour"
                  *ngIf="
                    f.submitted &&
                    phone.invalid &&
                    phone.errors &&
                    phone.errors.required
                  "
                >
                  <span
                    class="fa fa-exclamation-circle mr-1"
                    type="Icon"
                  ></span>
                  Phone number is required
                </div>
                <div [hidden]="phone.valid || phone.pristine" class="boxcolour">
                  <span
                    class="fa fa-exclamation-circle mr-1"
                    type="Icon"
                  ></span>
                  Please enter a valid phone number
                </div>
              </div>
            </div>
            <div class="col-12 text-left">
              <label
                class="commercialColour editLabel"
                for="email"
                style="line-height: 17px !important"
                >Email address</label
              >
              <input
                type="text"
                class="form-control inputBox editLabel"
                name="email"
                [(ngModel)]="quesResponse.emailAddress"
                #email="ngModel"
                [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
                id="contactEmail"
                (input)="legalClick()"
                required
                email
                pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
              />
              <div class="invalid-feedback posabs">
                <div
                  class="boxcolour"
                  *ngIf="
                    f.submitted &&
                    email.invalid &&
                    email.errors &&
                    email.errors.required
                  "
                >
                  <span class="fa fa-exclamation-circle mr-1" type="Icon"></span
                  >Email is required
                </div>
                <div
                  [hidden]="
                    email.valid || email.pristine || !email.errors.pattern
                  "
                  class="boxcolour"
                >
                  <span class="fa fa-exclamation-circle mr-1" type="Icon"></span
                  >Please enter a valid email
                </div>
              </div>
            </div>
            <div class="col-12 text-left">
              <div class="lneHegt commercialColour editLabel">
                Legal Entity Name
              </div>
              <input
                type="text"
                class="form-control inputBox editLabel"
                id="legalEntityName"
                name="LegalEntityName"
                [(ngModel)]="quesResponse.legalEntityName"
                #legalEntityName="ngModel"
                (input)="legalClick()"
              />
            </div>
            <!-- </div>
        <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0"> -->

            <div class="col-12 text-left">
              <div class="lneHegt commercialColour editLabel">
                Your Title / position
              </div>
              <input
                type="text"
                class="form-control inputBox editLabel"
                id="yourTitlePosition"
                (input)="legalClick()"
                name="YourTitlePosition"
                [(ngModel)]="quesResponse.yourTitlePosition"
                #yourTitlePosition="ngModel"
              />
            </div>
            <!-- </div>
        <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0"> -->

            <div class="col-12 text-left">
              <div class="lneHegt commercialColour editLabel">
                Best Time To Contact
              </div>
              <select
                class="dropdown-toggle form-control inputBox editLabel minhgt45"
                id="bestTimeToContact"
                name="BestTimeToContact"
                [(ngModel)]="quesResponse.bestTimeToContact"
                #bestTimeToContact="ngModel"
              >
                <option value="8am - 11am">8am - 11am</option>
                <option value="11am - 2pm">11am - 2pm</option>
                <option value="2pm - 6pm">2pm - 6pm</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12 mb-2 ml-0 mr-0">
            <div class="lneHegt commercialColour editLabel">
              Billing Address
            </div>
            <div class="row col-sm-12 m-0 p-0">
              <div class="col-12 text-left p-0">
                <input
                  type="text"
                  class="form-control inputBox editLabel"
                  id="billingAddress"
                  name="BillingAddress"
                  [(ngModel)]="quesResponse.billingAddress"
                  #billingAddress="ngModel"
                  (input)="legalClick()"
                />
              </div>
              <!-- <div class="col-3 text-left pr-0">
              <div class="lneHegt commercialColour editLabel"></div>
              <input type="text" class="form-control inputBox editLabel" value="Suite#" />
            </div> -->
            </div>
          </div>

          <div class="col-sm-12 pr-3 text-right">
            <button
              [disabled]="contactSaveBtn"
              class="sectbtn signinpad mt-4 pl-3 pr-3 rounded handsymbol float-right mt-1 editSave"
              type="submit"
            >
              SAVE
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Show the product preference edit model -->
  <div *ngIf="showMobileproductEdit && mbEditShowLocation === false">
    <div class="col-12 d-flex mt-3">
      <div class="justify-content-center align-self-center col-sm-3 col-3 px-0">
        <img
          style="width: 100% !important"
          src="assets/images/logo-charcoal.png"
        />
      </div>
      <div class="col-sm-9 col-9 px-0 my-auto">
        <div class="arrow_box">
          <h1 class="questionMob text-left mbmainHeading evaMsg pl-2">
            Did I correctly capture your contract requests and product
            preferences?
          </h1>
        </div>
      </div>
    </div>
    <div class="col-10 m-auto p-0 datepicker">
      <div class="w-100 d-inline-block p-0 borderbox mb-4 mt-4 pb-3">
        <img
          src="assets/images/editClose.svg"
          class="close videoclose outlinee closeBtn pt-2 mr-2"
          width="15"
          (click)="mobileProductClose()"
        />
        <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
          <p class="text-left m-0 lneHegt editText">
            Edit your product preferences
          </p>
        </div>
        <form
          name="productForm"
          (ngSubmit)="
            createProductPreference($event, f1, f1.form.valid, 'mobileProd')
          "
          #f1="ngForm"
          novalidate
        >
          <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mt-2">
            <div class="col-12 text-left">
              <div class="lneHegt commercialColour editLabel">Service type</div>
              <input
                disabled
                type="text"
                class="form-control inputBox editLabel"
                id="serviceType"
                name="ServiceType"
                [(ngModel)]="services[index].value"
                #serviceType="ngModel"
              />
            </div>
            <div
              *ngIf="
                services[index].value === 'Switching Providers' &&
                expirations[index].value !== 'No, already expired'
              "
              class="col-12 text-left"
            >
              <div class="lneHegt commercialColour editLabel">
                Contract expiration date
              </div>
              <div class="wrdwrp lneHegt editLabel">
                <div class="datePickerShow">
                  <my-date-picker
                    name="mydate1"
                    id="date1"
                    [options]="myDatePickerOptions1"
                    [(ngModel)]="model"
                    placeholder="DD/MM/YYYY"
                    required
                  ></my-date-picker>
                </div>
              </div>
            </div>
            <div
              *ngIf="
                services[index].value === 'Switching Providers' &&
                expirations[index].value === 'No, already expired'
              "
              class="col-6 text-left"
            >
              <div class="lneHegt commercialColour editLabel">
                Contract expiration date
              </div>
              <div class="wrdwrp">No, already expired</div>
            </div>
            <div
              *ngIf="services[index].value === 'Switching Providers'"
              class="col-12 text-left"
            >
              <div class="lneHegt commercialColour editLabel">Product Type</div>
              <select
                class="dropdown-toggle form-control inputBox editLabel minhgt45"
                id="requestedProductType"
                name="RequestedProductType"
                [(ngModel)]="quesResponse.requestedProductType"
                #requestedProductType="ngModel"
              >
                <option value="Fixed rate">Fixed rate</option>
                <option value="Variable & index rate">
                  Variable & index rate
                </option>
              </select>
            </div>
            <div
              *ngIf="services[index].value === 'Switching Providers'"
              class="col-12 text-left"
            >
              <div class="lneHegt commercialColour editLabel">
                Requested switch date
              </div>
              <div class="wrdwrp lneHegt editLabel">
                <div class="datePickerShow">
                  <my-date-picker
                    name="mydate2"
                    id="date2"
                    [options]="myDatePickerOptions2"
                    [(ngModel)]="switchModel"
                    placeholder="DD/MM/YYYY"
                    required
                  ></my-date-picker>
                </div>
              </div>
            </div>
            <div class="col-12 text-left">
              <div class="lneHegt commercialColour editLabel">
                Requested contract term
              </div>
              <select
                class="dropdown-toggle form-control inputBox editLabel minhgt45"
                id="requestedContractTerm"
                name="RequestedContractTerm"
                [(ngModel)]="quesResponse.requestedContractTerm"
                #requestedContractTerm="ngModel"
              >
                <option value="6 Months">6 Months</option>
                <option value="12 Months">12 Months</option>
                <option value="18 Months">18 Months</option>
                <option value="24 Months">24 Months</option>
                <option value="30 Months">30 Months</option>
                <option value="36 Months">36 Months</option>
                <option value="48 Months">48 Months</option>
                <option value="60 Months">60 Months</option>
                <option value="i don't know">i don't know</option>
              </select>
            </div>

            <div
              *ngIf="services[index].value === 'New Service'"
              class="col-12 text-left"
            >
              <div class="lneHegt commercialColour editLabel">
                Permits & inspections
              </div>
              <!-- <input type="text" class="form-control inputBox editLabel" id="permitInspectmb" name="PermitInspectmb" [(ngModel)]="quesResponse.reqpermits" #permitInspectmb="ngModel" /> -->
              <select
                class="dropdown-toggle form-control inputBox editLabel minhgt45"
                id="permitsInspection"
                name="PermitsInspection"
                [(ngModel)]="permissions[index].value"
                #permitsInspection="ngModel"
              >
                <option value="Yes">Yes</option>
                <option value="No, not yet">No, not yet</option>
                <option value="Not necessary">Not necessary</option>
                <option value="I need to get a permit?">
                  I need to get a permit?
                </option>
              </select>
            </div>
            <!-- </div>
      <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0"> -->

            <div
              *ngIf="services[index].value === 'New Service'"
              class="col-12 text-left"
            >
              <div class="lneHegt commercialColour editLabel">Project Type</div>
              <div class="wrdwrp lneHegt editLabel">
                <select
                  class="dropdown-toggle form-control inputBox editLabel minhgt45"
                  id="projectType"
                  name="ProjectType"
                  [(ngModel)]="projects[index].value"
                  #projectType="ngModel"
                >
                  <option value="New construction">New construction</option>
                  <option value="Building renovation">
                    Building renovation
                  </option>
                  <option value="Company expansion / new location">
                    Company expansion / new location
                  </option>
                  <option value="Change of ownership">
                    Change of ownership
                  </option>
                </select>
              </div>
            </div>

            <div
              *ngIf="services[index].value === 'New Service'"
              class="col-12 text-left"
            >
              <div class="lneHegt commercialColour editLabel">
                Requested start date
              </div>
              <div class="wrdwrp lneHegt editLabel">
                <div class="datePickerShow">
                  <my-date-picker
                    name="mydate3"
                    id="date3"
                    [options]="myDatePickerOptions3"
                    [(ngModel)]="startDateValue"
                    placeholder="DD/MM/YYYY"
                    required
                  ></my-date-picker>
                </div>
              </div>
            </div>
            <!-- </div>
      <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0">         -->
          </div>
          <div class="col-sm-12 pr-3 text-right">
            <button
              class="sectbtn signinpad mt-4 pl-3 pr-3 rounded handsymbol mt-1 editSave"
              type="submit"
            >
              SAVE
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Show Business model - Mobileview -->
<div
  *ngIf="yesCheckBox && confirmcheckbox"
  class="container text-center mobileview"
>
  <div
    *ngIf="
      mobileShowLocation &&
      showMobileproductEdit === false &&
      ShowMobileModel === false &&
      mbEditShowLocation === false
    "
    class="h-100 mt-3"
  >
    <div class="col-12 d-flex px-0 b-3">
      <div class="justify-content-center align-self-center col-sm-3 col-3 px-0">
        <img
          style="width: 100% !important"
          src="assets/images/logo-charcoal.png"
        />
      </div>
      <div class="col-sm-9 col-9 pr-0 my-auto pb-4">
        <div class="arrow_box">
          <h1 class="questionMob text-left editmobileHeading evaMsg pl-2">
            Please confirm your location details. And just so you know, to
            receive accurate, custom pricing options we require two recent
            energy bills for each ESI ID.
          </h1>
        </div>
      </div>
    </div>
    <div
      id="businessLocationScroll"
      class="col-10 m-auto float-right borderbox p-0 mb-4"
    >
      <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
        <p class="text-left m-0 lneHegt subHeading editSubHeading">
          Your location details ({{ addresses.length }})
          <a
            class="float-right mt-0 mr-2 editIcon"
            (click)="editLocationMobile()"
            ><img src="assets/images/ediPencil.svg" width="15" />
          </a>
        </p>
      </div>
      <div class="contactInfobotm mb-1 ml-2 mr-2">
        <div
          *ngFor="let addressObj of addresses; let i = index"
          class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mt-2"
        >
          <!-- <div class="col-4 text-left">
              <div class="col-md-12 mb-2 px-0 ">
                <agm-map [latitude]="addressObj.geoMapAddress.geometry.location.lat" [longitude]="addressObj.geoMapAddress.geometry.location.lng" [zoomControl]= false [disableDoubleClickZoom] = true [zoom]=18 [scrollwheel]=false [streetViewControl]=false>
                    <agm-marker [latitude]="addressObj.geoMapAddress.geometry.location.lat" [longitude]="addressObj.geoMapAddress.geometry.location.lng" [iconUrl]=" markerIconUrl()"></agm-marker>
                  </agm-map>
            </div>
            </div> -->
          <div class="col-12 text-left">
            <div class="lneHegt commercialColour serviceAddress">
              Service Address ({{ i + 1 }})
            </div>
            <div class="wrdwrp lneHegt serviceAddressContent">
              <p class="mb-1 lneHegt">{{ addressObj.formatedAddress }}</p>
              <p class="mb-0">TDSP: {{ addressObj.utility }}</p>
              <!-- {{addressObj.pointer_name}} -->

              <p
                class="mb-0"
                *ngFor="let esiid of addressObj.esiids; let j = index"
              >
                ESI ID: {{ esiid.value }}
              </p>
              <p class="mb-0">
                Requested Start Date: {{ switchDates[i] | date: mediumDate }}
              </p>
              <!-- <div *ngFor="let switchDate of requestSwitchDateValue; let k = index;">
                 Requested switch date: {{ switchDate.value.date }}
               </div>                -->
            </div>
          </div>
          <div class="text-center m-auto dragMsg">
            Receive accurate, tailored pricing options
          </div>
          <div
            class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mb-3 pb-3 mt-2 border-bottom"
          >
            <div class="col-sm-12 text-center font16 semi-bold">
              <label
                class="upload-button text-center handsymbol boxbackgrdclr"
                [ngClass]="{ 'another-file-over': hasAnotherDropZoneOver }"
              >
                <div
                  ng2FileDrop
                  (fileOver)="fileOverAnother($event, i)"
                  [uploader]="uploader"
                >
                  <!-- <span style="line-height: 100% !important">
                      <font class="font16 semi-bold" style="line-height: 100% !important">TAP TO UPLOAD BILLS OR TAKE A PICTURE</font><br>
                      <font class="font13" style="line-height: 100% !important">Max File Size: 10MB</font>
                      <font class="font13" style="line-height: 100% !important">Acceptable File Types: JPG, PNG, PDF</font>
                    </span> -->
                  <span>
                    <p
                      class="mt-0 mb-0"
                      style="
                        line-height: 100% !important;
                        font-size: 15px;
                        font-family: Calibre-Semibold;
                      "
                    >
                      TAP TO UPLOAD BILLS OR TAKE A PICTURE
                    </p>
                    <p
                      class="mt-0 mb-0"
                      style="
                        line-height: 100% !important;
                        font-size: 12px;
                        font-family: Calibre;
                      "
                    >
                      Max File Size: 10MB
                    </p>
                    <p
                      class="mt-0 mb-0"
                      style="
                        line-height: 100% !important;
                        font-size: 12px;
                        font-family: Calibre;
                      "
                    >
                      Acceptable File Types: JPG, PNG, PDF
                    </p>
                  </span>
                </div>
                <input
                  type="file"
                  name="photo"
                  ng2FileSelect
                  id="{{ 'file' + i }}"
                  name="{{ 'addressId-' + i }}"
                  (click)="onTempImageSelected($event, i)"
                  [uploader]="uploader"
                  accept=".jpg,.pdf,.jpeg,.png,.svg,.bmp"
                  multiple
                />
              </label>
              <ul class="upldfile">
                <li *ngFor="let fileobj of uploader.queue">
                  <div
                    class="handsymbol uploaded"
                    *ngIf="i === fileobj.file.fileIndex"
                  >
                    <i class="fa fa-file mr-2"></i>
                    <span
                      >{{ fileobj.file.name }}
                      <small class="text-muted clearfix float-left w-100">{{
                        fileobj.file.unitSize
                      }}</small>
                    </span>
                    <font class="upldclose" (click)="removeFile(fileobj)"
                      >x</font
                    >
                  </div>
                </li>
                <li class="uploaderror" *ngIf="invalidFileMsg">
                  Please provide image or pdf files
                </li>
                <li class="uploaderror" *ngIf="invalidFileSizeMsg">
                  File(s) size shouldn't exceed 10 MB
                </li>
              </ul>
            </div>
          </div>
          <!-- <hr /> -->
        </div>
      </div>
    </div>
    <div class="col-10 m-auto text-left float-right p-0">
      <label class="custom-control custom-checkbox mb-2 mt-4 w-100 chkbox pl-0">
        <input
          class="custom-control-input mgntp10"
          id="confirm3"
          name="property"
          type="checkbox"
          value="confirm"
          (click)="confirmBtn('mobile')"
        />
        <label class="custom-control-label confirmBtn" for="confirm3"
          >Confirm</label
        ></label
      >
    </div>
    <div *ngIf="mbBusinessclick" class="col-10 m-auto float-right p-0">
      <div class="col-12 p-0 w-100 text-right">
        <div
          class="mb-3 ash_box text-right ng-tns-c16-2 ng-trigger ng-trigger-flyOutans ng-star-inserted"
          style="transform: translateX(0px)"
        >
          <h1 class="ansMob text-right confirmMsg">Confirmed, what’s next?</h1>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      mbEditShowLocation &&
      showMobileproductEdit === false &&
      ShowMobileModel === false
    "
  >
    <div class="col-12 d-flex mt-3">
      <div class="justify-content-center align-self-center col-sm-3 col-3 px-0">
        <img
          style="width: 100% !important"
          src="assets/images/logo-charcoal.png"
        />
      </div>
      <div class="col-sm-9 col-9 px-0 my-auto">
        <div class="arrow_box">
          <h1 class="questionMob text-left editmobileHeading evaMsg pl-2">
            Please confirm your location details. And just so you know, to
            receive accurate, custom pricing options we require two recent
            energy bills for each ESI ID.
          </h1>
        </div>
      </div>
    </div>
    <div class="col-10 m-auto p-0">
      <div class="w-100 d-inline-block p-0 borderbox mb-4 mt-4 pb-3">
        <img
          src="assets/images/editClose.svg"
          class="close videoclose outlinee closeBtn pt-2 mr-2"
          width="15"
          (click)="mobileBusinessClose()"
        />
        <div class="contactInfobotm pl-3 pr-3 pt-2 pb-2 border-bottom">
          <p class="text-left m-0 lneHegt editSubHeading">
            Edit your location details
          </p>
        </div>
        <div class="p-0">
          <div class="contactInfobotm mb-1 ml-2 mr-2">
            <div
              *ngFor="let addressObj of temporaryAddresses; let i = index"
              class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mt-2"
            >
              <div class="col-12 text-left">
                <div class="lneHegt commercialColour editServiceHead">
                  Service Address ({{ i + 1 }})
                </div>
                <!-- <div class="wrdwrp lneHegt serviceAddressContent">{{addressObj.formatedAddress}}<br>
              </div> -->
                <div class="row m-0">
                  <div class="col-12 pl-0 mb-3">
                    <input
                      ngx-google-places-autocomplete
                      [options]="options"
                      #places="ngx-places"
                      (ngModelChange)="setFlag()"
                      (keydown.space)="
                        addressObj.pointer_name ? null : $event.preventDefault()
                      "
                      (onAddressChange)="handleAddressChange($event, i)"
                      type="text"
                      id="autocomplete"
                      class="form-control"
                      placeholder="Enter Business Name"
                      [(ngModel)]="addressObj.pointer_name"
                    />
                  </div>
                  <!-- <div class="col-3 p-0">
                      <input type="text" value="#suite" class="form-control editServiceHead" />
                    </div> -->
                </div>
                <div class="col-12 p-0 text-center">
                  <div class="col-12 col-md-12 mb-3 px-0">
                    <agm-map
                      [latitude]="
                        addressObj.geoMapAddress.geometry.location.lat
                      "
                      [longitude]="
                        addressObj.geoMapAddress.geometry.location.lng
                      "
                      [zoomControl]="false"
                      [disableDoubleClickZoom]="true"
                      [zoom]="18"
                      [scrollwheel]="false"
                      [streetViewControl]="false"
                    >
                      <agm-marker
                        [latitude]="
                          addressObj.geoMapAddress.geometry.location.lat
                        "
                        [longitude]="
                          addressObj.geoMapAddress.geometry.location.lng
                        "
                        [iconUrl]="markerIconUrl()"
                      ></agm-marker>
                    </agm-map>
                  </div>
                </div>
                <div class="col-12 text-left">
                  <!-- <div class="lneHegt commercialColour editServiceHead">
                  Service address({{i+1}})
                </div>                   -->
                  <!-- <div class="wrdwrp lneHegt serviceAddressContent">{{addressObj.formatedAddress}}<br> -->
                  <!-- <div class="wrdwrp lneHegt serviceAddressContent"> -->
                  <div class="col-12 p-0 mb-3">
                    <input
                      (keydown.space)="
                        addressObj.formatedAddress
                          ? null
                          : $event.preventDefault()
                      "
                      type="text"
                      class="form-control editServiceHead"
                      placeholder="Street address, City, State"
                      id="addAddress{{ i }}"
                      name="AddAddress"
                      [(ngModel)]="addressObj.formatedAddress"
                      #addAddress="ngModel"
                    />
                    <!-- <input type="text" class="form-control" placeholder="Enter Business name"/> -->
                  </div>
                  <div class="d-flex mb-2">
                    <div
                      class="col pt-2 pr-0 pl-0 commercialColour editServiceHead"
                    >
                      TDSP:
                    </div>
                    <div class="col-9 p-0">
                      <!-- <input type="text" id="pointerName" name="PointerName" [(ngModel)]="addressObj.pointer_name" #pointerName="ngModel" class="form-control editServiceHead" /> -->
                      <input
                        type="text"
                        id="pointerName"
                        name="PointerName"
                        value="{{ addressObj.utility }}"
                        class="form-control editServiceHead"
                        readonly
                      />
                    </div>
                  </div>
                  <!-- TDSP: {{addressObj.pointer_name}}<br> -->
                  <!-- <p class="mb-1" *ngFor="let esiid of addressObj.esiids; let j = index;">ESI ID: {{esiid.value}}</p> -->
                  <div
                    class="d-flex mb-2"
                    *ngFor="let esiid of addressObj.esiids; let j = index"
                  >
                    <div
                      class="col pt-2 pr-0 pl-0 commercialColour editServiceHead"
                    >
                      ESI ID{{ j + 1 }}:
                    </div>
                    <div class="col-9 p-0">
                      <input
                        type="text"
                        id="esiidVal{{ i }}"
                        name="EsiidVal"
                        [(ngModel)]="esiid.value"
                        #esiidVal="ngModel"
                        class="form-control editServiceHead"
                      />
                      <span class="CloseEssid"
                        ><img
                          class="outlinee closeBtn"
                          src="assets/images/editClose.svg"
                          (click)="essidClose(i, j)"
                          width="15"
                      /></span>
                    </div>
                  </div>
                  <!-- <div class="text-left">
                  Requested Start
                  <br> Date:
                </div>  -->

                  <div class="text-right">
                    <div
                      class="btn sectbtn signinpad mt-0 mb-0 pl-2 pr-2 pt-0 pb-0 editServiceHead"
                      (click)="addEsiid(i)"
                    >
                      Add ESI ID
                    </div>
                  </div>
                  <hr />

                  <!-- <input ngx-google-places-autocomplete [options]="options" #places="ngx-places" (ngModelChange)="setFlag()"
                  (keydown.space)="formatedAddress ? null : $event.preventDefault()"
                  (onAddressChange)="handleAddressChange($event)" type="text" id="autocomplete" class="form-control editServiceHead"
                  placeholder="Street address, City, State" id="addAddress" name="AddAddress" [(ngModel)]="addressObj.formatedAddress" #addAddress="ngModel"/>
                  <br>
                  <font class="col-4 editServiceHead commercialColour">TDSP:</font>
                  <input type="text" id="pointerName" name="PointerName" [(ngModel)]="addressObj.pointer_name" #pointerName="ngModel" class="form-control col-8 float-right editServiceHead" />
                   <br>
                 <p *ngFor="let esiid of addressObj.esiids; let j = index;">                           
                      <font class="col-4 editServiceHead commercialColour">ESI ID {{i+1}}</font>
                      <input type="text" id="esiidVal" name="EsiidVal" [(ngModel)]="esiid.value" #esiidVal="ngModel" class="form-control col-8 float-right editServiceHead" />
                    
                  </p>
                 <p>Requested switch date:</p> -->
                </div>
              </div>
              <!-- <div class="text-center m-auto dragMsg">Receive accurate, tailored pricing options</div>
              <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0 mt-2 borfderbtm">
                  <div class="col-sm-12 text-center font16 semi-bold oneSpaces mb-2">
                    <label class="upload-button text-center handsymbol boxbackgrdclr" [ngClass]="{'another-file-over': hasAnotherDropZoneOver}">
                      <div ng2FileDrop (fileOver)="fileOverAnother($event)" [uploader]="uploader">
                        <span>
                          <font class="font16 semi-bold oneSpaces">DRAG AND DROP OR CLICK HERE TO UPLOAD</font><br>
                          <font class="font13 oneSpaces">Max File Size: 10MB</font>
                        </span>
                      </div>
                      <input type="file" name="photo" ng2FileSelect [uploader]="uploader" accept=".jpg,.pdf,.jpeg,.png,.svg,.bmp"
                        multiple>
                    </label>
                    <ul class="upldfile">
                      <li class="handsymbol" *ngFor="let fileobj of uploader.queue">
                        <i class="fa fa-file mr-2"></i>
                        <span>{{fileobj.file.name}}
                          <small class="text-muted clearfix float-left w-100">{{fileobj.file.unitSize}}</small>
                        </span>
                        <font class="upldclose" (click)="removeFile(fileobj)">x</font>
                      </li>
                      <li class="uploaderror" *ngIf="invalidFileMsg">Please provide image or pdf files</li>
                      <li class="uploaderror" *ngIf="invalidFileSizeMsg">File(s) size shouldn't exceed 10 MB</li>
                    </ul>
                  </div>
                </div> -->
            </div>
          </div>
        </div>
        <div class="text-right col-sm-12 pr-3">
          <button
            class="sectbtn signinpad mt-4 pl-3 pr-3 rounded handsymbol mt-1 editSaveBtn"
            (click)="businessEdit('mbBusiness')"
            type="submit"
          >
            SAVE
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #template>
  <div class="modal-header py-0">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <h4 class="utility-modal-title font20 text-center text-uppercase">
      Multiple Utilities in {{ zipcode }}
    </h4>
    <p class="utility-sub-title font20 text-center">
      Please select your utility from the list below:
    </p>
    <div class="col-sm-12 mb-2" *ngFor="let utility of utilities">
      <div class="d-flex m-auto col-sm-12 col-md-12 col-xl-6">
        <div class="modal-cards w-100">
          <div
            class="card card-list pt-2 text-center"
            id="{{ utility.Utility }}"
            (click)="selectUtility(utility.Utility)"
          >
            <div class="d-flex m-auto col-sm-12 col-md-12 col-xl-6">
              <img src="{{ utility.src }}" height="50" />
            </div>
            <label
              class="utility-sub-title font16"
              for="{{ utility.Utility }}"
              >{{ utility.Utility }}</label
            >
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="col-12 text-center">
      <p class="utility-sub-title font15" *ngIf="isAddressSelected">
        Thank you! Your utility selection is saved.
      </p>
      <button
        class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase"
        (click)="modalRef.hide()"
      >
        Next
      </button>
    </div>
  </div>
</ng-template>
<ng-template #noservice>
  <div class="modal-header py-0">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <h4 class="utility-modal-title font20 text-center text-uppercase">
      SERVICE IS UNAVAILABLE FOR {{ zipcode }}
    </h4>
    <p class="utility-sub-title font20">
      We’re sorry we don’t have a say in which areas are open to energy choice.
      If it were up to us, we’d love to have you as our newest customer!
    </p>
    <p class="utility-sub-title font20">
      Check back with us in the future or send us an email. We’d love to stay
      connected with you!
    </p>
    <br />
    <div class="col-12 text-center">
      <button
        class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase"
        (click)="modalRef.hide()"
      >
        HELP
      </button>
    </div>
    <p class="utility-sub-title font20">
      Who do you know that would like to help make this world a better, brighter
      place while finding a deal on energy? Please share and let them know about
      us!
    </p>
    <div class="sidebar-ftr">
      <ul class="list-inline mb-5">
        <li>
          <a
            href="https://www.facebook.com/honestgorilla1/"
            class="px-0"
            target="_blank"
            ><img src="assets/images/facebook-co.svg" width="48px"
          /></a>
        </li>
        <li>
          <a
            href="https://twitter.com/honestgorilla"
            class="px-0"
            target="_blank"
            ><img src="assets/images/twitter-co.svg" width="48px"
          /></a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/honestgorilla_energy/ "
            class="px-0"
            target="_blank"
            ><img src="assets/images/instragram-co.svg" width="48px"
          /></a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
